import { useEffect } from 'react'
import { trackInternalEvent } from '@rio/tracking'
import ReactDOM from 'react-dom'
import { DocumentTypes } from 'builder/modules/constants'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import SelectResumeModal from 'builder/views/ResumeDistributionView/components/SelectResumeModal'

import { InfoBox, SuccessBox } from '../../'
import { WidgetTheme } from '../../WidgetTheme'
import { WidgetProps } from '../../widget.types'
import { WidgetContainer, WidgetBox } from '../../widget.styles'

import { useThemeConfig } from '../../hooks/useThemeConfig'
import { useResumeTailoringConfig } from './hooks/useResumeTailoringConfig'
import { useResumeTailoringActions } from './hooks/useResumeTailoringActions'

import * as Styles from './styles'
import ResumeTailoringImage from './assets/illustration.png'
import ResumeTailoringMobileImage from './assets/ilustration-mobile.png'

export const ResumeTailoring = ({ service }: WidgetProps) => {
  const { isPhone } = useMediaQueries()
  const theme = useThemeConfig({ service })
  const { text, status } = useResumeTailoringConfig(service)
  const { showResumeSelect, setShowResumeSelect, handleCompletedClick, onResumeTailoring } =
    useResumeTailoringActions(service)

  const isCompleted = status === 'completed'
  const src = isPhone ? ResumeTailoringMobileImage : ResumeTailoringImage

  const handleClick = () => {
    trackInternalEvent('progress_cta_click', {
      score: service.title,
      cta: text.actionText,
    })
    if (isCompleted) return handleCompletedClick()
    setShowResumeSelect(true)
  }

  useEffect(() => {
    if (isCompleted) {
      trackInternalEvent('progress_score_completed', { score: service.title })
    }
  }, [isCompleted, service.title])

  return (
    <WidgetTheme theme={theme[status]} tipOrder={service.widgetTipOrder}>
      <WidgetContainer>
        <WidgetBox>
          <InfoBox
            text={text}
            isCompleted={isCompleted}
            handleClick={handleClick}
            data-testid={`resume-tailoring-info-${status}`}
            actionButtonTestId={`resume-tailoring-action-button-${status}`}
          />
        </WidgetBox>
        <WidgetBox>
          {isCompleted ? (
            <SuccessBox />
          ) : (
            <Styles.Image src={src} data-testid={`resume-tailoring-illustration-box-${status}`} />
          )}
        </WidgetBox>
      </WidgetContainer>
      {showResumeSelect &&
        ReactDOM.createPortal(
          <SelectResumeModal
            isDocumentLoaded
            title={text.modalTitle}
            onClose={() => setShowResumeSelect(false)}
            submitSelectedResume={onResumeTailoring}
            viewOnly={DocumentTypes.resume}
          />,
          document.body,
        )}
    </WidgetTheme>
  )
}
